(() => {
  const RUNOFF_COLLECTION_URL = '/collections/runoff';
  const CART_URL = '/cart';

  function overlay() {
    return document.getElementById('runoffOverlay');
  }

  function modal() {
    return document.getElementById('runoffModal');
  }

  function el(id) {
    return document.getElementById(id);
  }

  function normalizeVendor(vendor) {
    return String(vendor || '').toUpperCase().trim();
  }

  function moneyCOPFromCents(cents) {
    try {
      return new Intl.NumberFormat('es-CO', {
        style: 'currency',
        currency: 'COP',
        maximumFractionDigits: 0
      }).format((cents || 0) / 100);
    } catch (e) {
      return '$' + Math.round((cents || 0) / 100).toLocaleString('es-CO');
    }
  }

  function openModal() {
    if (!overlay() || !modal()) return;
    overlay().style.display = 'block';
    modal().style.display = 'block';
  }

  function closeModal() {
    if (!overlay() || !modal()) return;
    overlay().style.display = 'none';
    modal().style.display = 'none';
    closeMini();
  }

  let miniLoaded = false;

  function openMini() {
    const mini = el('runoffMini');
    if (mini) mini.classList.add('is-open');

    const actions = modal()?.querySelector('.runoff-actions');
    if (actions) actions.style.display = 'none';

    if (!miniLoaded) {
      loadMiniCatalog();
    }
  }

  function closeMini() {
    const mini = el('runoffMini');
    if (mini) mini.classList.remove('is-open');

    const actions = modal()?.querySelector('.runoff-actions');
    if (actions) actions.style.display = '';
  }

  async function getCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!res.ok) throw new Error('No se pudo leer /cart.js');
    return res.json();
  }

  function countRunoffItems(cart) {
    let count = 0;

    for (const item of cart.items || []) {
      const vendor = normalizeVendor(item.vendor);
      if (vendor === 'RUNOFF') {
        count += Number(item.quantity || 0);
      }
    }

    return count;
  }

  async function loadMiniCatalog() {
    miniLoaded = true;

    const grid = el('runoffGrid');
    const loading = el('runoffMiniLoading');
    const status = el('runoffMiniStatus');

    if (!grid || !loading) return;

    loading.style.display = 'block';
    grid.innerHTML = '';

    if (status) {
      status.style.display = 'none';
      status.textContent = '';
    }

    try {
      const res = await fetch(`${RUNOFF_COLLECTION_URL}/products.json?limit=8`, {
        credentials: 'same-origin'
      });

      if (!res.ok) throw new Error('No se pudo cargar products.json');

      const data = await res.json();
      const products = data.products || [];

      loading.style.display = 'none';

      if (!products.length) {
        grid.innerHTML = '<p style="grid-column:1/-1;">No se encontraron modelos Runoff.</p>';
        return;
      }

      products.forEach((product) => {
        const firstImage = product?.images?.[0]?.src || '';
        const firstVariant = product?.variants?.[0];
        const firstVariantPrice = firstVariant?.price
          ? Math.round(parseFloat(firstVariant.price) * 100)
          : 0;

        const variants = (product.variants || []).filter((variant) => variant.available);

        const card = document.createElement('div');
        card.className = 'runoff-card';

        const options = variants
          .map((variant) => {
            const label = variant.title || 'Talla';
            return `<option value="${variant.id}">${label}</option>`;
          })
          .join('');

        card.innerHTML = `
          ${firstImage ? `<img src="${firstImage}" alt="${product.title}">` : ''}
          <div class="t">${product.title}</div>
          <div class="p">${moneyCOPFromCents(firstVariantPrice)}</div>

          <select class="runoff-variant" ${variants.length ? '' : 'disabled'}>
            ${
              variants.length
                ? `<option value="">Selecciona talla</option>${options}`
                : `<option value="">Sin stock</option>`
            }
          </select>

          <button class="runoff-add" type="button" disabled>
            AGREGAR 2º PAR
          </button>
        `;

        const select = card.querySelector('.runoff-variant');
        const button = card.querySelector('.runoff-add');

        if (select && button) {
          select.addEventListener('change', () => {
            button.disabled = !select.value;
          });

          button.addEventListener('click', async () => {
            const variantId = select.value;
            if (!variantId) return;

            button.disabled = true;
            button.textContent = 'AGREGANDO...';

            try {
              const addRes = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                credentials: 'same-origin',
                body: JSON.stringify({
                  id: Number(variantId),
                  quantity: 1
                })
              });

              if (!addRes.ok) {
                throw new Error('No se pudo agregar el segundo par');
              }

              if (status) {
                status.style.display = 'block';
                status.textContent = '✅ Segundo par agregado. Ya tienes la promo activa.';
              }

              button.textContent = '¡LISTO!';

              setTimeout(() => {
                closeModal();
              }, 900);
            } catch (err) {
              console.warn('[Runoff Mini Add]', err);
              button.disabled = false;
              button.textContent = 'ERROR, INTENTA';
            }
          });
        }

        grid.appendChild(card);
      });
    } catch (e) {
      console.warn('[Mini catalog]', e);
      loading.textContent = 'No se pudo cargar el catálogo. Intenta de nuevo.';
    }
  }

  function bindButtons() {
    document.addEventListener('click', (e) => {
      const target = e.target;
      if (!target) return;

      if (target.id === 'runoffClose') {
        closeModal();
        return;
      }

      if (target === overlay()) {
        closeModal();
        return;
      }

      if (target.id === 'runoffGoCollection') {
        openMini();
        return;
      }

      if (target.id === 'runoffMiniBack') {
        closeMini();
        return;
      }

      if (target.id === 'runoffMiniSeeAll') {
        window.location.href = RUNOFF_COLLECTION_URL;
        return;
      }

      if (target.id === 'runoffGoCart' || target.id === 'runoffMiniGoCart') {
        window.location.href = CART_URL;
      }
    });
  }

  function interceptAddToCart() {
    document.addEventListener(
      'submit',
      (e) => {
        const form = e.target;
        if (!(form instanceof HTMLFormElement)) return;

        const action = form.getAttribute('action') || '';
        if (!action.includes('/cart/add')) return;

        const fd = new FormData(form);
        const addedId = fd.get('id');

        setTimeout(async () => {
          try {
            const cart = await getCart();

            const addedItem = (cart.items || []).find(
              (item) => String(item.id) === String(addedId)
            );

            if (!addedItem) return;

            const addedVendor = normalizeVendor(addedItem.vendor);
            if (addedVendor !== 'RUNOFF') return;

            const runoffQty = countRunoffItems(cart);
            if (runoffQty === 1) {
              openModal();
            }
          } catch (err) {
            console.warn('[Runoff Popup add intercept]', err);
          }
        }, 900);
      },
      true
    );
  }

  function init() {
    bindButtons();
    interceptAddToCart();
  }

  document.addEventListener('DOMContentLoaded', init);
})();